var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackboardChartSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 12 12",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12v12h-12z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.75 6.625h4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 6.625v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 6.625v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 10.5-.5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 10.5.5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.4625 8.50000003h-6.925-.00000005c-.572995 0-1.0375-.46450453-1.0375-1.03750003v-4.925.00000016c0-.572995.4645045-1.03750013 1.0375-1.03750013h6.9245.00000005c.572995-.00027599 1.037725.46400463 1.038 1.03700013v.00050012 4.9245-.00000664c.0002799.572995-.4639979 1.037725-1.03699489 1.03800639-.00016669 0-.00033338 0-.00050008 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 6.625v-1.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackboardChartSecond);
export default __webpack_public_path__ + "static/media/blackboard-chart-second.3bb71d91c2f5f4a6d90798201254cff2.svg";
export { ForwardRef as ReactComponent };